import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Chat
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type ChatParameters = ChatMessageDeletedParameters | ChatTextCreatedParameters | ChatFileCreatedParameters | ChatTagAddedParameters | ChatTagmenuOpenedParameters | ChatSearchExecutedParameters;
export type ChatEvents = ChatMessageDeletedEvent | ChatTextCreatedEvent | ChatFileCreatedEvent | ChatTagAddedEvent | ChatTagmenuOpenedEvent | ChatSearchExecutedEvent;

export interface ChatMessageDeletedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	messageId: string; // ID of the deleted chat message
}

export type ChatMessageDeletedParametersSpecific = Omit<
	ChatMessageDeletedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const chatMessageDeletedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ChatMessageDeletedEventBuilder {
	constructor(private specificParameters: ChatMessageDeletedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ChatMessageDeletedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ChatMessageDeletedParametersSpecific,
            ChatMessageDeletedParameters,
			(params: ChatMessageDeletedParameters) => ChatMessageDeletedEvent
		>(this.specificParameters, chatMessageDeletedParametersGlobal, globalParams, (params) => new ChatMessageDeletedEvent(params));
	}
}

/**
 * A user deleted a message from the chat.
 */
export class ChatMessageDeletedEvent extends CraftnoteEvent<ChatMessageDeletedParameters>{
  constructor(parameters: ChatMessageDeletedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "chat_message_deleted"
		},
		{
			name: "iterable",
			eventName: "chat_message_deleted"
		},
	]);
  }
}
export interface ChatTextCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type ChatTextCreatedParametersSpecific = Omit<
	ChatTextCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const chatTextCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ChatTextCreatedEventBuilder {
	constructor(private specificParameters: ChatTextCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ChatTextCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ChatTextCreatedParametersSpecific,
            ChatTextCreatedParameters,
			(params: ChatTextCreatedParameters) => ChatTextCreatedEvent
		>(this.specificParameters, chatTextCreatedParametersGlobal, globalParams, (params) => new ChatTextCreatedEvent(params));
	}
}

/**
 * A user send a text message to the chat.
 */
export class ChatTextCreatedEvent extends CraftnoteEvent<ChatTextCreatedParameters>{
  constructor(parameters: ChatTextCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "add_textmessage"
		},
		{
			name: "iterable",
			eventName: "chat_text_created"
		},
	]);
  }
}
export interface ChatFileCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	mimeType: string; // MIME type of the uploaded file
	source: string; // source of the action, possible values are "camera", "audio", "storage", "scanner", "share", "pdf-editor", "photo-editor"
}

export type ChatFileCreatedParametersSpecific = Omit<
	ChatFileCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const chatFileCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ChatFileCreatedEventBuilder {
	constructor(private specificParameters: ChatFileCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ChatFileCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ChatFileCreatedParametersSpecific,
            ChatFileCreatedParameters,
			(params: ChatFileCreatedParameters) => ChatFileCreatedEvent
		>(this.specificParameters, chatFileCreatedParametersGlobal, globalParams, (params) => new ChatFileCreatedEvent(params));
	}
}

/**
 * A user uploaded a file to the chat. If multiple files are uploaded, multiple events should be sent.
 */
export class ChatFileCreatedEvent extends CraftnoteEvent<ChatFileCreatedParameters>{
  constructor(parameters: ChatFileCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "chat_file_created"
		},
		{
			name: "iterable",
			eventName: "chat_file_created"
		},
	]);
  }
}
export interface ChatTagAddedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	type: string; // type of the tagged message, possible values are "text", "image", "video", "audio", "document", if the file type is unsupported we use "document" similar to the message type
}

export type ChatTagAddedParametersSpecific = Omit<
	ChatTagAddedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const chatTagAddedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ChatTagAddedEventBuilder {
	constructor(private specificParameters: ChatTagAddedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ChatTagAddedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ChatTagAddedParametersSpecific,
            ChatTagAddedParameters,
			(params: ChatTagAddedParameters) => ChatTagAddedEvent
		>(this.specificParameters, chatTagAddedParametersGlobal, globalParams, (params) => new ChatTagAddedEvent(params));
	}
}

/**
 * A user added a tag to an existing message. The message can be of any type (text, image, video, etc.). Set the type parameter to distinguish.
 */
export class ChatTagAddedEvent extends CraftnoteEvent<ChatTagAddedParameters>{
  constructor(parameters: ChatTagAddedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "assign_tag"
		},
		{
			name: "iterable",
			eventName: "chat_tag_added"
		},
	]);
  }
}
export interface ChatTagmenuOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type ChatTagmenuOpenedParametersSpecific = Omit<
	ChatTagmenuOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const chatTagmenuOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ChatTagmenuOpenedEventBuilder {
	constructor(private specificParameters: ChatTagmenuOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ChatTagmenuOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ChatTagmenuOpenedParametersSpecific,
            ChatTagmenuOpenedParameters,
			(params: ChatTagmenuOpenedParameters) => ChatTagmenuOpenedEvent
		>(this.specificParameters, chatTagmenuOpenedParametersGlobal, globalParams, (params) => new ChatTagmenuOpenedEvent(params));
	}
}

/**
 * A user opened the tag menu.
 */
export class ChatTagmenuOpenedEvent extends CraftnoteEvent<ChatTagmenuOpenedParameters>{
  constructor(parameters: ChatTagmenuOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "open_tag_menu"
		},
		{
			name: "iterable",
			eventName: "chat_tagmenu_opened"
		},
	]);
  }
}
export interface ChatSearchExecutedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type ChatSearchExecutedParametersSpecific = Omit<
	ChatSearchExecutedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const chatSearchExecutedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ChatSearchExecutedEventBuilder {
	constructor(private specificParameters: ChatSearchExecutedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ChatSearchExecutedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ChatSearchExecutedParametersSpecific,
            ChatSearchExecutedParameters,
			(params: ChatSearchExecutedParameters) => ChatSearchExecutedEvent
		>(this.specificParameters, chatSearchExecutedParametersGlobal, globalParams, (params) => new ChatSearchExecutedEvent(params));
	}
}

/**
 * A user executed a chat search within a project.
 */
export class ChatSearchExecutedEvent extends CraftnoteEvent<ChatSearchExecutedParameters>{
  constructor(parameters: ChatSearchExecutedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "click_search_in_project"
		},
		{
			name: "iterable",
			eventName: "chat_search_executed"
		},
	]);
  }
}
